import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {UserPasswordFormModule} from '../../user-management/user-password/user-password-form/user-password-form.module';
import {UpdatePasswordComponent} from './update-password.component';

@NgModule({
  declarations: [UpdatePasswordComponent],
  imports: [UserPasswordFormModule, RouterModule],
})
export class UpdatePasswordModule {}



// WEBPACK FOOTER //
// ./src/app/auth/update-password/update-password.module.ts